import { useWindowSize } from '@leaftrade/leaftrade-component-library';

const QUICK_ORDER_TABLE_MIN_HEIGHT = 300;
const QUICK_ORDER_TABLE_VIEWPORT_OFFSET = 290;

const useQuickOrderTableHeight = () => {
  const { height: windowHeight } = useWindowSize();

  return Math.max(
    (windowHeight || 0) - QUICK_ORDER_TABLE_VIEWPORT_OFFSET,
    QUICK_ORDER_TABLE_MIN_HEIGHT
  );
};

export default useQuickOrderTableHeight;
